module.exports = "pegasus/assets/gray-large-twitter.png";